import React from "react";
import GlassCard from "@/components/brand/GlassCard";
import FadeUp from "@/components/brand/FadeUp";

const ROWS = [
    { label: "Length", value: "6 weeks", color: "#EC4899" },
    { label: "Schedule", value: "Once per week, 2 hours", color: "#8B5CF6" },
    { label: "Pilot size", value: "5–8 students", color: "#3B82F6" },
    { label: "Student cost", value: "Free through sponsored seats", color: "#14B8A6" },
    { label: "Primary tool", value: "Emergent", color: "#FBBF24" },
    { label: "Backup tools", value: "Canva, browser-based tools, light HTML/CSS", color: "#EC4899" },
    { label: "Final outcome", value: "Safe, parent-approved personal portfolio website", color: "#8B5CF6" },
];

export const ProgramSnapshot = () => {
    return (
        <FadeUp>
            <GlassCard
                className="p-6 sm:p-8"
                hoverLift={false}
                data-testid="program-snapshot"
            >
                <h3
                    className="text-xs font-semibold uppercase tracking-wider mb-5"
                    style={{ color: "var(--text-secondary)" }}
                >
                    Program Snapshot
                </h3>
                <ul className="divide-y divide-white/10">
                    {ROWS.map((row) => (
                        <li
                            key={row.label}
                            className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4 py-3.5"
                        >
                            <span className="flex items-center gap-3 text-sm font-medium" style={{ color: "var(--text-secondary)" }}>
                                <span
                                    className="inline-block w-2 h-2 rounded-full flex-shrink-0"
                                    style={{
                                        background: row.color,
                                        boxShadow: `0 0 8px ${row.color}80`,
                                    }}
                                    aria-hidden="true"
                                />
                                {row.label}
                            </span>
                            <span className="text-sm sm:text-right font-medium" style={{ color: "var(--text-primary)" }}>
                                {row.value}
                            </span>
                        </li>
                    ))}
                </ul>
            </GlassCard>
        </FadeUp>
    );
};

export default ProgramSnapshot;
